import {gql} from '@apollo/client';
import {
  ACCOUNT_DETAILS_FRAGMENT,
  CONTACT_BASIC_FRAGMENT,
  CONTACT_SEARCH_FRAGMENT,
  VULNERABILITY_FRAGMENT,
} from '../../graphql/fragments';

export const CONTACT_SEARCH_QUERY = gql`
  query ContactSearchQuery($search: String) {
    contactsSearch(search: $search) {
      ...ContactSearchFragment
    }
  }
  ${CONTACT_SEARCH_FRAGMENT}
`;

export const CONTACT_PAGE_QUERY = gql`
  query ContactPageQuery($contactId: UUID!) {
    contactDetails(contactId: $contactId) {
      ...Vulnerabilities
      ...ContactBasicFragment
      accountContacts {
        id
        isPrimary
        account {
          ...AccountDetailsFragment
        }
      }
      id
      name
      firstName
      middleName
      lastName
      spouseName
      salutation
      curoId
      simplifiedName
      primaryPhone
      workPhone
      secondaryPhone
      homePhone
      familyStatus
      gender
      isDeleted
      dob
      anniversary
      fullAddress
      compositeAddress
      addressee
      email
      jobTitle
      workPhone
      contactStatus
      knownAs
      fullAddress
      clientNumber
      gender
      isMinor
      clientNumber
      isVulnerable
      giaHasLiquidityNeeds
      pensionHasLiquidityNeeds
    }
  }
  ${CONTACT_BASIC_FRAGMENT}
  ${ACCOUNT_DETAILS_FRAGMENT}
  ${VULNERABILITY_FRAGMENT}
`;
